'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Section: You May Also Like
   *******************************/
  function handleRecommendedProducts(elm, replaceSelector) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(elm);

      fetch(elm.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(replaceSelector);
            const replaceElm = elm.querySelector(replaceSelector);

            if (recommendations && recommendations.innerHTML.trim().length) {
              replaceElm.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              replaceElm.classList.add('product-recommendations--loaded');
            }

            checkInitRecommendProducts();
          })
          .catch(e => {
            console.error(e);
          });
    }

    new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 400px 0px'}).observe(elm);
  }

  const sectionsRecommendation = document.querySelectorAll('.section-recommendation');
  sectionsRecommendation.forEach(function (elm) {
    handleRecommendedProducts(elm, '.replace-items_js');
  });

  function initSwiperSlider(selector, options) {
    options = options || {
      slidesPerView: 2,
      spaceBetween: 10,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };

    return new Swiper(selector, options);
  }

  const checkInitRecommendProducts = () => {
    const productRecommendItems = Array.from(document.querySelectorAll('.section-recommendation .slider-item'));

    console.log(`productRecommendItems: ${productRecommendItems}`)

    if (window.innerWidth >= 1200) {
      productRecommendItems.length > 4 ? initSwiperSlider('.slider-recommendation_init') : '';
    } else if (window.innerWidth >= 768) {
      productRecommendItems.length > 3 ? initSwiperSlider('.slider-recommendation_init') : '';
    } else if (window.innerWidth <= 767) {
      productRecommendItems.length > 2 ? initSwiperSlider('.slider-recommendation_init') : '';
    }
  }

  /********************************
   * Section: Section Collection List
   *******************************/
  const initCollectionListSlider = () =>{
    new Swiper('.collection-slider_init',{
      slidesPerView: 2,
      spaceBetween: 10,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }
    });
  }

  const checkInitSwiperSlider = () => {
    const collectionItems = Array.from(document.querySelectorAll('.section-collection-list .swiper-slide'));

    if (window.innerWidth >= 1200) {
      collectionItems.length > 4 ? initCollectionListSlider() : '';
    } else if (window.innerWidth >= 768) {
      collectionItems.length > 3 ? initCollectionListSlider() : '';
    } else if (window.innerWidth <= 767) {
      collectionItems.length > 2 ? initCollectionListSlider() : '';
    }
  }

  checkInitSwiperSlider();


  const initCollectiotabSlider = () => {
    // Check if a Swiper instance already exists on the element to avoid duplicates
    if (document.querySelector('.tab-content .collection-tab_init').swiper) {
      document.querySelector('.tab-content .collection-tab_init').swiper.destroy(true, true);
    }
  
    // Initialize Swiper
    new Swiper('.tab-content .collection-tab_init', {
      slidesPerView: 2,
      spaceBetween: 10,
      speed: 1300,
      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }
    });
  }
  
  const checktabSwiperSlider = () => {
    const collectionItems = Array.from(document.querySelectorAll('.tab-content .swiper-slide'));
    if (window.innerWidth >= 1200) {
      if (collectionItems.length > 3) initCollectiotabSlider();
    } else if (window.innerWidth >= 768) {
      if (collectionItems.length > 3) initCollectiotabSlider();
    } else if (window.innerWidth <= 767) {
      if (collectionItems.length > 2) initCollectiotabSlider();
    }
  }
  
  // Tab functionality
  document.querySelectorAll('.tab-title').forEach(button => {
    button.addEventListener('click', function() {
      // Hide all tab content
      document.querySelectorAll('.tab-content').forEach(content => content.style.display = 'none');
      
      // Remove active class from all tabs
      document.querySelectorAll('.tab-title').forEach(tab => tab.classList.remove('active'));
  
      // Show the selected tab content
      const selectedTab = document.getElementById('tab-' + this.dataset.collection);
      selectedTab.style.display = 'block';
  
      // Add active class to the clicked tab
      this.classList.add('active');
      
      // Update collection name
      const selectedCollectionName = this.dataset.collectionname;
      const collectionSpan = document.querySelector('.view_collection span');
      const collectionLink = document.querySelector('.view_collection');
      const selectedCollectionUrl = this.dataset.collectionUrl;
      collectionSpan.textContent = selectedCollectionName;
      collectionLink.href = selectedCollectionUrl; 
  
      // Initialize Swiper after the tab content loads
      setTimeout(checktabSwiperSlider, 200);  // Adjust delay as needed
    });
  });
  
  // Show the first tab content by default and add active class
  const firstTab = document.querySelector('.tab-title');
  if (firstTab) {
    firstTab.click();
  }
  


  const initblogListSlider = () =>{
    new Swiper('.blog-slider_init',{
      slidesPerView: 1.2,
      spaceBetween: 10,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }
    });
  }

  const checkblogSwiperSlider = () => {
    const blogItems = Array.from(document.querySelectorAll('.section-blog-list .swiper-slide'));

    if (window.innerWidth >= 1200) {
      blogItems.length > 4 ? initblogListSlider() : '';
    } else if (window.innerWidth >= 768) {
      blogItems.length > 3 ? initblogListSlider() : '';
    } else if (window.innerWidth <= 767) {
      blogItems.length > 2 ? initblogListSlider() : '';
    }
  }

  checkblogSwiperSlider();


  
  const initvideoListSlider = () =>{
    new Swiper('.video-slider_init',{
      slidesPerView: 1.2,
      spaceBetween: 10,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }
    });
  }

  const checkvideoSwiperSlider = () => {
    const videoItems = Array.from(document.querySelectorAll('.video-slider_init .swiper-slide'));

    if (window.innerWidth >= 1200) {
      videoItems.length > 4 ? initvideoListSlider() : '';
    } else if (window.innerWidth >= 768) {
      videoItems.length > 3 ? initvideoListSlider() : '';
    } else if (window.innerWidth <= 767) {
      videoItems.length > 2 ? initvideoListSlider() : '';
    }
  }

  checkvideoSwiperSlider();

  const imagetextInitSwiperSlider = () =>{
    new Swiper('.slider-imagetext',{
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });
  }

  imagetextInitSwiperSlider();

  const comparisonSwiperSlider = () =>{
    new Swiper('.slider-comparison',{
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      }
    });
  }

  comparisonSwiperSlider();
});




